export default __webpack_public_path__ + "static/media/payment-success-bottom.08da2125.svg";